import React from "react";
import { Accordion } from "react-bootstrap";

const OrderFaq: React.FC = () => {
  const faqs = [
    {
      id: 1,
      question: "What is the processing time for the Emirates ID?",
      answer: "It typically takes 5–7 working days after medical approval.",
    },
    {
      id: 2,
      question: "How can I track my visa status?",
      answer:
        "Login to your account and go to 'My Orders' to see live updates.",
    },
    {
      id: 3,
      question: "What does 'In-process' mean?",
      answer:
        "'In-process' means your documents have been submitted and are under review.",
    },
    {
      id: 4,
      question: "Can I renew my Emirates ID online?",
      answer:
        "Yes, once your eligibility is verified, you can renew it through the app or portal.",
    },
  ];

  return (
    <div className="row up-form-r layout-border rounded-3">
      {/* Header */}
      <div className="d-flex justify-content-between align-items-center mb-1 p-3 border-bottom py-2">
        <div>
          <h1 className="ff-semibold text-black mb-1 font-18">
            Frequently asked questions
          </h1>
          <p className="font-13 text-muted mb-0">Please check your orders</p>
        </div>
      </div>

      <div className="p-0 table-search border-bottom d-flex align-items-center gap-2 ps-3 up-form">
        <div>
          <svg
            width="14"
            height="14"
            viewBox="0 0 14 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M1 5.59587C1 6.24096 1.12071 6.87974 1.35523 7.47572C1.58975 8.07171 1.93349 8.61323 2.36683 9.06938C2.80018 9.52553 3.31462 9.88737 3.88081 10.1342C4.447 10.3811 5.05383 10.5082 5.66667 10.5082C6.2795 10.5082 6.88634 10.3811 7.45252 10.1342C8.01871 9.88737 8.53316 9.52553 8.9665 9.06938C9.39984 8.61323 9.74358 8.07171 9.97811 7.47572C10.2126 6.87974 10.3333 6.24096 10.3333 5.59587C10.3333 4.95078 10.2126 4.31201 9.97811 3.71603C9.74358 3.12004 9.39984 2.57852 8.9665 2.12237C8.53316 1.66622 8.01871 1.30438 7.45252 1.05752C6.88634 0.810654 6.2795 0.683594 5.66667 0.683594C5.05383 0.683594 4.447 0.810654 3.88081 1.05752C3.31462 1.30438 2.80018 1.66622 2.36683 2.12237C1.93349 2.57852 1.58975 3.12004 1.35523 3.71603C1.12071 4.31201 1 4.95078 1 5.59587Z"
              stroke="#9B9B9B"
              strokeWidth="1.2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M13 13.316L9 9.10547"
              stroke="#9B9B9B"
              strokeWidth="1.2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </div>
        <input
          type="text"
          className="form-control myorders-search p-0 border-0 rounded-0 mb-0"
          placeholder="Search orders ID, status, service"
        />
      </div>

      <div className="px-3 mb-3 d-flex gap-3 order-action-buttons pt-3">
        <button className="action-btn active">
          <span className="icon">
            <svg
              width="16"
              height="21"
              viewBox="0 0 16 21"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M5 3.25H3C2.46957 3.25 1.96086 3.46071 1.58579 3.83579C1.21071 4.21086 1 4.71957 1 5.25V17.25C1 17.7804 1.21071 18.2891 1.58579 18.6642C1.96086 19.0393 2.46957 19.25 3 19.25H13C13.5304 19.25 14.0391 19.0393 14.4142 18.6642C14.7893 18.2891 15 17.7804 15 17.25V5.25C15 4.71957 14.7893 4.21086 14.4142 3.83579C14.0391 3.46071 13.5304 3.25 13 3.25H11"
                stroke="#000"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              ></path>
              <path
                d="M5 3.25C5 2.71957 5.21071 2.21086 5.58579 1.83579C5.96086 1.46071 6.46957 1.25 7 1.25H9C9.53043 1.25 10.0391 1.46071 10.4142 1.83579C10.7893 2.21086 11 2.71957 11 3.25C11 3.78043 10.7893 4.28914 10.4142 4.66421C10.0391 5.03929 9.53043 5.25 9 5.25H7C6.46957 5.25 5.96086 5.03929 5.58579 4.66421C5.21071 4.28914 5 3.78043 5 3.25Z"
                stroke="#000"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              ></path>
              <path
                d="M5 10.25H11"
                stroke="#000"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              ></path>
              <path
                d="M5 14.25H11"
                stroke="#000"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              ></path>
            </svg>
          </span>
          <span className="text">General</span>
        </button>
        <button className="action-btn ">
          <span className="icon">
            <svg
              width="19"
              height="18"
              viewBox="0 0 19 18"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M8 10.7501C8 11.811 8.42143 12.8285 9.17158 13.5787C9.92172 14.3288 10.9391 14.7503 12 14.7503C13.0609 14.7503 14.0783 14.3288 14.8284 13.5787C15.5786 12.8285 16 11.811 16 10.7501C16 9.68924 15.5786 8.67178 14.8284 7.92161C14.0783 7.17144 13.0609 6.75 12 6.75C10.9391 6.75 9.92172 7.17144 9.17158 7.92161C8.42143 8.67178 8 9.68924 8 10.7501Z"
                stroke="#282828"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              ></path>
              <path
                d="M15.5 14.25L18 16.7501"
                stroke="#282828"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              ></path>
              <path
                d="M1 1.75H17"
                stroke="#282828"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              ></path>
              <path
                d="M1 7.75H5.00001"
                stroke="#282828"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              ></path>
              <path
                d="M1 13.75H5.00001"
                stroke="#282828"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              ></path>
            </svg>
          </span>
          <span className="text">Orders</span>
        </button>

        <button className="action-btn ">
          <span className="icon">
            <svg
              width="21"
              height="16"
              viewBox="0 0 21 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M5.5 10.9056H2.5C2.23478 10.9056 1.98043 10.8003 1.79289 10.6127C1.60536 10.4252 1.5 10.1708 1.5 9.90561V1.90561C1.5 1.64039 1.60536 1.38604 1.79289 1.1985C1.98043 1.01097 2.23478 0.905609 2.5 0.905609H14.5C14.7652 0.905609 15.0196 1.01097 15.2071 1.1985C15.3946 1.38604 15.5 1.64039 15.5 1.90561V4.90561"
                stroke="black"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M5.5 5.90561C5.5 5.64039 5.60536 5.38604 5.79289 5.1985C5.98043 5.01097 6.23478 4.90561 6.5 4.90561H18.5C18.7652 4.90561 19.0196 5.01097 19.2071 5.1985C19.3946 5.38604 19.5 5.64039 19.5 5.90561V13.9056C19.5 14.1708 19.3946 14.4252 19.2071 14.6127C19.0196 14.8003 18.7652 14.9056 18.5 14.9056H6.5C6.23478 14.9056 5.98043 14.8003 5.79289 14.6127C5.60536 14.4252 5.5 14.1708 5.5 13.9056V5.90561Z"
                stroke="black"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M10.5 9.90561C10.5 10.436 10.7107 10.9447 11.0858 11.3198C11.4609 11.6949 11.9696 11.9056 12.5 11.9056C13.0304 11.9056 13.5391 11.6949 13.9142 11.3198C14.2893 10.9447 14.5 10.436 14.5 9.90561C14.5 9.37518 14.2893 8.86647 13.9142 8.4914C13.5391 8.11632 13.0304 7.90561 12.5 7.90561C11.9696 7.90561 11.4609 8.11632 11.0858 8.4914C10.7107 8.86647 10.5 9.37518 10.5 9.90561Z"
                stroke="black"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </span>
          <span className="text">Payment</span>
        </button>

        <button className="action-btn ">
          <span className="icon">
            <svg
              width="16"
              height="18"
              viewBox="0 0 16 18"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M3.12109 4.24333C3.12109 5.10351 3.46279 5.92847 4.07102 6.53671C4.67924 7.14495 5.50418 7.48666 6.36434 7.48666C7.2245 7.48666 8.04943 7.14495 8.65766 6.53671C9.26588 5.92847 9.60758 5.10351 9.60758 4.24333C9.60758 3.38314 9.26588 2.55819 8.65766 1.94995C8.04943 1.34171 7.2245 1 6.36434 1C5.50418 1 4.67924 1.34171 4.07102 1.94995C3.46279 2.55819 3.12109 3.38314 3.12109 4.24333Z"
                stroke="black"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M1.5 15.595V13.9733C1.5 13.1131 1.8417 12.2882 2.44992 11.6799C3.05815 11.0717 3.88308 10.73 4.74324 10.73H6.77027"
                stroke="black"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M10.418 13.9733C10.418 14.4034 10.5888 14.8159 10.8929 15.12C11.197 15.4241 11.6095 15.595 12.0396 15.595C12.4697 15.595 12.8821 15.4241 13.1862 15.12C13.4904 14.8159 13.6612 14.4034 13.6612 13.9733C13.6612 13.5432 13.4904 13.1307 13.1862 12.8266C12.8821 12.5225 12.4697 12.3517 12.0396 12.3517C11.6095 12.3517 11.197 12.5225 10.8929 12.8266C10.5888 13.1307 10.418 13.5432 10.418 13.9733Z"
                stroke="black"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M12.042 11.1354V12.3517"
                stroke="black"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M12.042 15.595V16.8112"
                stroke="black"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M14.4995 12.5544L13.4463 13.1625"
                stroke="black"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M10.6371 14.7841L9.58301 15.3923"
                stroke="black"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M9.58301 12.5544L10.6371 13.1625"
                stroke="black"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M13.4463 14.7841L14.5003 15.3923"
                stroke="black"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </span>
          <span className="text">My Account</span>
        </button>
      </div>
      <div>
        <Accordion defaultActiveKey="">
          {faqs.map((faq, index) => (
            <Accordion.Item
              eventKey={String(index)}
              key={faq.id}
              className="mb-2 applicant-view"
            >
              <Accordion.Header>{faq.question}</Accordion.Header>
              <Accordion.Body>{faq.answer}</Accordion.Body>
            </Accordion.Item>
          ))}
        </Accordion>
      </div>
    </div>
  );
};

export default OrderFaq;
